import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_NOTIFICATION_COUNT } from '@/graphql/query.graphql';
import { ObtainNotificationCountQuery } from '@/types/generated/graphql';

export const cacheUpdateSeenNotification = (id: number) => {
  cache.modify({
    id: 'NotificationV2:' + id,
    fields: {
      seenAt() {
        return new Date().toISOString();
      },
    },
  });
};

export const cacheUpdateNotificationCount = () => {
  cache.updateQuery<ObtainNotificationCountQuery>({ query: QUERY_GET_NOTIFICATION_COUNT }, (data) => {
    const previousCount = data?.obtainNotificationCount?.data?.count;
    const newCount = previousCount > 0 ? previousCount - 1 : 0;
    return {
      ...data,
      obtainNotificationCount: {
        ...data?.obtainNotificationCount,
        data: {
          ...data?.obtainNotificationCount?.data,
          count: newCount,
        },
      },
    };
  });
};
